import { createFileRoute } from "@tanstack/react-router";
import FirstResponderInsuranceVerification from "@/pages/FirstResponderInsuranceVerification";
export const Route = createFileRoute("/first-responder-insurance-verification")(
  {
    component: RouteComponent,
    head() {
      return {
        meta: [
          {
            title:
              "First Responder Insurance Verification | Neuro Wellness TMS",
          },
          {
            name: "description",
            content:
              "Verify your insurance for TMS, SAINT TMS, and SPRAVATO as a first responder. Free benefits check for police, fire, and EMS in Coral Springs, FL.",
          },
          {
            property: "og:title",
            content:
              "First Responder Insurance Verification | Neuro Wellness TMS",
          },
          {
            property: "og:description",
            content:
              "Verify your insurance for TMS, SAINT TMS, and SPRAVATO as a first responder. Free benefits check for police, fire, and EMS in Coral Springs, FL.",
          },
          {
            property: "og:url",
            content:
              "https://neurowellnesstms.com/first-responder-insurance-verification",
          },
          {
            property: "og:type",
            content: "website",
          },
          {
            name: "twitter:card",
            content: "summary_large_image",
          },
        ],
        links: [
          {
            rel: "canonical",
            href: "https://neurowellnesstms.com/first-responder-insurance-verification",
          },
        ],
      };
    },
  },
);
function RouteComponent() {
  return <FirstResponderInsuranceVerification />;
}
